// extracted by mini-css-extract-plugin
export default {"root":"FacesTooltip__root--MuE9q","title":"FacesTooltip__title--1EDN_","text":"FacesTooltip__text--1hFVc","button":"FacesTooltip__button--1iUxh","close":"FacesTooltip__close--32To5"};